import { render, staticRenderFns } from "./i-liked-comments.vue?vue&type=template&id=f4dfd252&scoped=true&lang=html&"
import script from "./i-liked-comments.vue?vue&type=script&lang=js&"
export * from "./i-liked-comments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dfd252",
  null
  
)

export default component.exports